import { Module } from "wrapper6";

var $ = jQuery;

export default class Tickets extends Module {

    ready(app) {

        $( document ).ready(function() {
            var event_id = $('#buy-tickets input[name="event_id"]').val();
            var hasBeenSuccessValidated = false;

            $('#buy-tickets').submit(function (e) {
                if(!hasBeenSuccessValidated) {

                    var tickets = 0;
                    var _this = $(this);
                    $('.choose_tickets').find('.error_msg').remove();

                    _this.find('.choose_tickets').find('input').each(function () {
                        if (!isNaN(parseInt($(this).val()))) {
                            tickets += parseInt($(this).val());
                        }
                    });

                    if (tickets <= 0 || isNaN(tickets)) {
                        e.preventDefault();

                        $('.choose_tickets').prepend('<div class="label error_msg"><p class="error">' + no_tickets + '</p></div>');

                    } else {
                        e.preventDefault();

                        var data = {
                            'action': 'validate_number_of_tickets',
                            'tickets': tickets,
                            'event_id': event_id
                        };

                        jQuery.post(woocommerce_params.ajax_url, data, function (response) {
                            if (response != 0) {
                                if (response.passed === 'disallow') {
                                    $('.choose_tickets').prepend('<div class="label error_msg"><p class="error">' + response.message + '</p></div>');
                                } else {
                                    hasBeenSuccessValidated = true;
                                    $('#buy-tickets').trigger('submit');
                                }
                            }
                        });
                    }
                }
            });
        });

        $('.buy-clubcard-select').change(function(){
            if($(this).val() !== ''){
                $(this).next().removeClass('disabled');
            }else {
                $(this).next().addClass('disabled');
            }
        });
    }
}